import { IFeedback } from './interfaces';
import { SliderOptions } from '@dealroadshow/uikit-slider';
import goldmanSachsLogo from '@framework/assets/customers/svg/goldmanSachs.svg';
import citibankLogo from '@framework/assets/customers/svg/citibank.svg';
import loandepotLogo from '@framework/assets/customers/svg/loanDepot.svg';
import creditSuisseLogo from '@framework/assets/customers/svg/creditSuisse.svg';
import firstkeyLogo from '@framework/assets/customers/svg/firstKey.svg';
import williamBlairLogo from '@framework/assets/customers/svg/williamBlair.svg';
import onemainLogo from '@framework/assets/customers/svg/oneMainFinancial.svg';
import crossRiverLogo from '@framework/assets/customers/svg/crossRiver.svg';
import bankOfAmericaLogo from '@framework/assets/customers/svg/bankOfAmerica.svg';
import willisLogo from '@framework/assets/customers/svg/willisLease.svg';
import styles from './feedbacks.module.scss';

const generateSliderSettings = ({
  pagination = false,
  navigation = false,
  loop = false,
  autoplay = false,
  rows = 1,
  wrapperClassName,
}: {
  pagination?: boolean,
  navigation?: boolean,
  loop?: boolean,
  autoplay?: boolean,
  rows?: number,
  wrapperClassName?: string,
}): SliderOptions & { wrapperClassName?: string } => {
  return {
    wrapperClassName,
    pagination: pagination ? { clickable: true } : false,
    navigation,
    loop,
    speed: 500,
    slidesPerView: rows,
    ...(autoplay && {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    }),
    breakpoints: {
      0: {
        slidesPerView: 1,
        grid: { rows: 1 },
        slidesPerGroup: 1,
      },
      641: {
        slidesPerView: 2,
        grid: { rows: 1 },
        slidesPerGroup: 2,
      },
      769: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        ...((rows > 1) && { grid: { rows, fill: 'row' } }),
      },
      1196: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        ...((rows > 1) && { grid: { rows, fill: 'row' } }),
      },
    },
  };
};

export const slidersSettingsTypes = {
  default: generateSliderSettings({
    autoplay: true,
    loop: true,
    wrapperClassName: styles.grab,
    pagination: true,
  }),
  grid: generateSliderSettings({
    pagination: true,
    rows: 3,
    wrapperClassName: styles.grid,
  }),
};

export const feedbacksList: IFeedback[] = [
  {
    imageSrc: goldmanSachsLogo.src,
    imageAlt: 'Goldman Sachs',
    feedbackText: '“Thank you so much. Never had better service in my life. Thank you again!”',
    feedbackAuthor: 'Kaitlyn',
  },
  {
    imageSrc: citibankLogo.src,
    imageAlt: 'citibank',
    feedbackText: '“Thank you so much for all of your help with this transaction! We loved working with you and look forward to working together in following deals. Thank you again!"',
    feedbackAuthor: 'Adriana',
  },
  {
    imageSrc: loandepotLogo.src,
    imageAlt: 'loanDepot',
    feedbackText: '“Your team is always the best! I will never forget my Saturday morning fiasco when they completely saved me!”',
    feedbackAuthor: 'D.A.',
  },
  {
    imageSrc: goldmanSachsLogo.src,
    imageAlt: 'Goldman Sachs',
    feedbackText: '“I’m not just saying this but your customer service is some of the best I’ve ever seen in any space. We greatly value your teams responsiveness and the product you deliver.”',
    feedbackAuthor: 'Jeff',
  },
  {
    imageSrc: creditSuisseLogo.src,
    imageAlt: 'Credit Suisse',
    feedbackText: '“Our clients should be paying me to recommend your data room. It costs less, it’s faster and easier to use”',
    feedbackAuthor: 'Hakim',
  },
  {
    imageSrc: firstkeyLogo.src,
    imageAlt: 'FirstKey',
    feedbackText: '“I’m so happy we switched”',
    feedbackAuthor: 'T.D.',
  },
  {
    imageSrc: williamBlairLogo.src,
    imageAlt: 'WilliamBlair',
    feedbackText: '“The attention to detail and customer support and service impressed me a ton. The product has been great, super simple to use thus far and have found everything that I need very easily.”',
    feedbackAuthor: 'C.R',
  },
  {
    imageSrc: goldmanSachsLogo.src,
    imageAlt: 'Goldman Sachs',
    feedbackText: '“Thank you SO much! You guys are the best. This is why I recommend you for every deal."',
    feedbackAuthor: 'Stephanie',
  },
  {
    imageSrc: onemainLogo.src,
    imageAlt: 'OneMain Financial',
    feedbackText: '“I can’t believe how much progress you have made and how much you continue to innovate. Everything you do is valuable to us. Please give kudos to your team - I really mean it - this is great stuff.”',
    feedbackAuthor: 'D.S.',
  },
  {
    imageSrc: crossRiverLogo.src,
    imageAlt: 'cross river',
    feedbackText: '“Finsight customer service (as well as the platform itself) is top notch and we look forward to working together more.”',
    feedbackAuthor: 'Ryan',
  },
  {
    imageSrc: bankOfAmericaLogo.src,
    imageAlt: 'Bank Of America',
    feedbackText: '“Your team has the best customer service I’ve ever seen. Thank you so much!”',
    feedbackAuthor: 'Parul',
  },
  {
    imageSrc: willisLogo.src,
    imageAlt: 'Willis Lease',
    feedbackText: '“As always exceptionally quick and fanatical support. I’ve never worked with a support group as responsive as the Finsight team. It is a refreshing and pleasant experience.”',
    feedbackAuthor: 'J.W.',
  },
];
